import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "@/i18n/LanguageContext";

const SITE_URL = "https://facow360.com";
const ZONE_FR = "Verviers · Province de Liège · Belgique · Narbonne (FR) · Monde entier en distanciel";
const ZONE_EN = "Verviers · Province of Liège · Belgium · Narbonne (FR) · Worldwide remote";

const META = {
  fr: {
    home: {
      title: "FACOW360 — Géobiologie, Magnétisme & Bilan Vitalité · À distance dans le monde entier",
      description: `FACOW360 — méthode Fabrice Marini. Géobiologie, Magnétisme et Cuisine Vivante. Consultations en présentiel à Verviers et en province de Liège, à distance dans le monde entier. Antenne Narbonne (Aude, France) en développement.`,
    },
    geobiologie: {
      title: "Géobiologie de l'habitat · Présentiel Verviers-Liège & à distance Monde entier · FACOW360",
      description: `Géobiologie de l'habitat FACOW360 : analyse tellurique (Hartmann, Curry, Peyré), failles, eaux souterraines, ondes de forme. Présentiel à Verviers et province de Liège, consultations à distance dans le monde entier. Antenne Narbonne (Aude, France) en développement.`,
    },
    cuisine: {
      title: "Cuisine Vivante : les 5 piliers de la vitalité · Bilan 19€ international · FACOW360",
      description: `Cuisine vivante FACOW360 — système sanguin, Ayurvéda, naturopathie, chronobiologie, jeûne. Bilan de Vitalité Alimentaire 19 € livré par e-mail dans le monde entier. Ateliers présentiels à Verviers et province de Liège.`,
    },
    magnetisme: {
      title: "Magnétisme · Présentiel Verviers-Liège & séances à distance Monde entier · FACOW360",
      description: `Magnétisme FACOW360 : méthode naturelle pour libérer les blocages et soutenir la régénération vitale. Présentiel à Verviers et province de Liège, séances à distance dans le monde entier. Antenne Narbonne (Aude, France) en développement.`,
    },
    therapeutes: {
      title: "Thérapeutes recommandés — FACOW360 (en construction)",
      description: "Réseau de praticiens de confiance : énergétique, psycho-émotionnel, pratiques traditionnelles. Page en cours de finalisation.",
    },
    boutique: {
      title: "Boutique d'affiliation — FACOW360 (en construction)",
      description: "Sélection rigoureuse de matériel de cuisine, produits pour l'habitat et outils de soutien vibratoire. Page en cours de finalisation.",
    },
    contact: {
      title: "Contact — FACOW360 Verviers · Liège · Narbonne",
      description: `Contactez Fabrice Marini en priorité par WhatsApp Business ou SMS. Rendez-vous via Resalib. Géobiologie, magnétisme et cuisine vivante à ${ZONE_FR}.`,
    },
    devis: {
      title: "Demande de devis — FACOW360",
      description: "Étude personnalisée géobiologie pour domaines, châteaux, espaces professionnels et projets internationaux. Tarification claire, frais de route inclus.",
    },
    bilan: {
      title: "Bilan de Vitalité Alimentaire 19 € · Livré par e-mail dans le monde entier · FACOW360",
      description: "Bilan personnalisé FACOW360 (19 €) : analyse de profil (sang, Ayurvéda, chronobiologie), liste de courses sur-mesure, 3 recettes (Cantine/Chef/Étoilé), méthode du Chef. Livré par e-mail sous 48h dans le monde entier.",
    },
    bilan_conf: {
      title: "Confirmation du Bilan — FACOW360",
      description: "Votre code client unique FACOW-2026-XXXX et la suite de votre parcours FACOW360.",
    },
    tarifs: {
      title: "Tarifs officiels — FACOW360 Verviers · Liège · Narbonne",
      description: "Tarifs transparents FACOW360 : Bilan 19 €, magnétisme à distance 49 €, atelier cuisine à domicile 99 €, étude géobiologique habitat dès 149 €.",
    },
    frequences: {
      title: "Fréquences musicales — Solfeggio, 432 Hz, Schumann — FACOW360",
      description: "Page libre d'écoute : 174 / 285 / 396 / 417 / 432 / 528 / 639 / 741 / 7,83 / 852 / 963 Hz. Recherche YouTube, lecture manuelle, aucun démarrage automatique.",
    },
    sentinelles: {
      title: "Les Sentinelles Vertes — Plantes purificatrices · FACOW360",
      description: "Géobiologie appliquée : Fougère de Boston, Cactus Cereus, Sansevieria, Spathiphyllum, Chlorophytum, Pothos, Lierre. Le végétal comme biocapteur et équilibreur d'ions.",
    },
    legal: {
      title: "Mentions légales — FACOW360",
      description: "Informations légales FACOW360 : SIRET 10341399300017, siège 20 quai de Lorraine 11100 Narbonne, médiateur CM2C, TVA non applicable Art. 293 B CGI.",
    },
  },
  en: {
    home: {
      title: "FACOW360 — Geobiology, Magnetism & Vitality Assessment · Worldwide remote",
      description: "FACOW360 — Fabrice Marini's method. Geobiology, Magnetism and Living Cuisine. On-site consultations in Verviers and Province of Liège, remote consultations worldwide. Narbonne (Aude, France) branch coming.",
    },
    geobiologie: {
      title: "Habitat Geobiology · On-site Verviers-Liège & worldwide remote · FACOW360",
      description: "FACOW360 habitat geobiology: telluric analysis (Hartmann, Curry, Peyré), faults, underground water, shape-waves. On-site in Verviers and Province of Liège, remote consultations worldwide. Narbonne (Aude, France) branch coming.",
    },
    cuisine: {
      title: "Living Cuisine: 5 vitality pillars · €19 international assessment · FACOW360",
      description: "FACOW360 Living Cuisine — blood system, Ayurveda, naturopathy, chronobiology, fasting. €19 Vitality Assessment delivered by email worldwide. On-site workshops in Verviers and Province of Liège.",
    },
    magnetisme: {
      title: "Magnetism · On-site Verviers-Liège & worldwide remote · FACOW360",
      description: "FACOW360 magnetism: a natural method to release blockages and support vital regeneration. On-site in Verviers and Province of Liège, remote sessions worldwide. Narbonne (Aude, France) branch coming.",
    },
    therapeutes: {
      title: "Recommended Therapists — FACOW360 (under construction)",
      description: "A trusted network of practitioners: energetic, psycho-emotional, traditional. Page being finalised.",
    },
    boutique: {
      title: "Affiliate Shop — FACOW360 (under construction)",
      description: "Carefully selected kitchen equipment, habitat products and vibrational support tools. Page being finalised.",
    },
    contact: {
      title: "Contact — FACOW360 Verviers · Liège · Narbonne",
      description: `Reach Fabrice Marini primarily via WhatsApp Business or SMS. Booking through Resalib. Geobiology, magnetism and living cuisine in ${ZONE_EN}.`,
    },
    devis: {
      title: "Quote request — FACOW360",
      description: "Personalised geobiology study for estates, castles, professional spaces and international projects. Clear pricing, travel fees included.",
    },
    bilan: {
      title: "Nutritional Vitality Assessment €19 · Email-delivered worldwide · FACOW360",
      description: "Personalised FACOW360 assessment (€19): profile analysis (blood, Ayurveda, chronobiology), bespoke shopping list, 3 recipes (Cantine/Chef/Étoilé), Chef's method. Delivered by email within 48h worldwide.",
    },
    bilan_conf: {
      title: "Bilan confirmation — FACOW360",
      description: "Your unique FACOW-2026-XXXX client code and the next steps of your FACOW360 journey.",
    },
    tarifs: {
      title: "Official Pricing — FACOW360 Verviers · Liège · Narbonne",
      description: "Transparent FACOW360 pricing: Bilan €19, remote magnetism €49, home cuisine workshop €99, geobiological habitat study from €149.",
    },
    frequences: {
      title: "Musical Frequencies — Solfeggio, 432 Hz, Schumann — FACOW360",
      description: "Free listening page: 174 / 285 / 396 / 417 / 432 / 528 / 639 / 741 / 7.83 / 852 / 963 Hz. YouTube search, manual playback, no autoplay.",
    },
    sentinelles: {
      title: "The Green Sentinels — Purifying plants · FACOW360",
      description: "Applied geobiology: Boston Fern, Cereus Cactus, Sansevieria, Peace Lily, Spider Plant, Pothos, Ivy. Plants as bio-sensors and ion-balancers.",
    },
    legal: {
      title: "Legal Notice — FACOW360",
      description: "FACOW360 legal information: SIRET 10341399300017, registered office 20 quai de Lorraine 11100 Narbonne, CM2C mediator, VAT not applicable Art. 293 B French CGI.",
    },
  },
};

export const Seo = ({ page }) => {
  const { locale } = useLang();
  const dict = META[locale] || META.fr;
  const meta = dict[page] || dict.home;
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const canonical = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <html lang={locale} />
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={locale === "fr" ? "fr_FR" : "en_US"} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
    </Helmet>
  );
};
